export default "__VITE_ASSET__BPgZJsFs__"